import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useEnvironment } from '../contexts/EnvironmentContext';
import bookingService from '../services/bookingService';

/**
 * Whether this environment takes real bookings.
 *
 * The nav asks, so that "Bookings" appears for the people who have a diary and stays out of the
 * way of everybody else. Live booking needs an endpoint key, and the key's status is the honest
 * test of it, a schedule exists for every environment whether or not anything can book against
 * it. Asked once per environment; a failure means "no", because a nav item nobody can use is
 * worse than a missing one.
 */
export const useLiveBooking = () => {
  const { authenticatedFetch } = useAuth();
  const { selectedEnvironment } = useEnvironment();
  const envId = selectedEnvironment?.id;
  const [live, setLive] = useState(false);

  useEffect(() => {
    if (!envId) {
      setLive(false);
      return undefined;
    }
    let cancelled = false;
    bookingService.keyStatus(envId, authenticatedFetch)
      .then((status) => { if (!cancelled) setLive(!!status?.valid); })
      .catch(() => { if (!cancelled) setLive(false); });
    return () => { cancelled = true; };
    // authenticatedFetch is rebuilt on every AuthContext render; depending on it would loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [envId]);

  return live;
};

export default useLiveBooking;
